import { useState, Fragment, useEffect } from 'react'
import { FetchPostDestinations } from 'components/Fetch'
import { Outlet, useSearchParams } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { bucketsSelector, plannedPostsLayoutSelector } from 'services/post/selectors'
import { FetchBuckets } from 'components/Fetch/FetchBuckets'
import { setPlannedPostsView } from 'services/post'
import { isPlannedPostsLayout } from 'services/post/state'

export function HistoryRoute() {
  const buckets = useSelector(bucketsSelector)
  const [loading, setLoading] = useState(buckets.length === 0)
  const dispatch = useDispatch()
  const activeView = useSelector(plannedPostsLayoutSelector)
  const [searchParams, setSearchParams] = useSearchParams()
  const queryView = searchParams.get('view')

  useEffect(() => {
    if (isPlannedPostsLayout(queryView) && queryView !== activeView) {
      dispatch(setPlannedPostsView(queryView))
    }
  }, [activeView, dispatch, queryView])

  if (!isPlannedPostsLayout(queryView)) {
    setSearchParams({ view: activeView })
  }

  const onLoaded = () => setLoading(false)

  if (loading) {
    return <FetchBuckets onError={onLoaded} onFetched={onLoaded} />
  }

  return (
    <Fragment>
      <Outlet />
      <FetchPostDestinations />
    </Fragment>
  )
}

export default HistoryRoute
